

import {LOAD_REPORTS_ERROR, LOAD_REPORTS_REQUEST, LOAD_REPORTS_SUCCESS, SET_REPORT_URL} from "./reports-action-types";

const initialState = {
  loading: false,
  error: "",
  reports: [],
  reportUrl: null
};

export default (state = initialState, action ) => {
  const { reports, error, reportUrl } = action;
  switch(action.type) {

    case SET_REPORT_URL:
      return {
        ...state,
        reportUrl
      };

    case LOAD_REPORTS_REQUEST:
      return {
        ...state,
        loading: true
      };

    case LOAD_REPORTS_ERROR:
      return {
        ...state,
        loading: false,
        error
      };

    case LOAD_REPORTS_SUCCESS:
      return {
        ...state,
        loading: false,
        reports
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/modules/reports/reports-reducer.js